import React from "react";
import styles from "./Modal.module.css";
import Loading from "../Loading";

const Modal = ({
  job,
  name,
  email,
  applyName,
  portfolioName,
  link,
  phoneNumber,
  setIsModal,
  onSubmit,
  isDarkMode,
  isLoading,
}) => {
  return (
    <div className={styles.container}>
      <div
        className={
          !isDarkMode ? styles.modalContainer : styles.dark_modalContainer
        }
      >
        <header className={styles.header}>
          <div>
            {job?.lo === "en"
              ? "Please confirm your information."
              : "작성한 지원서의 내용을 확인해주세요."}
          </div>
        </header>
        <div className={!isDarkMode ? styles.title : styles.dark_title}>
          <div className={!isDarkMode ? styles.duty : styles.dark_duty}>
            {job?.duty}
          </div>
          <div className={!isDarkMode ? styles.type : styles.dark_type}>
            {job?.type}
          </div>
        </div>
        <div className={styles.applyInfo}>
          <div className={styles.infoTitle}>
            {job?.lo === "en" ? "Personal Information" : "인적 사항"}
          </div>
          <div className={styles.nameBox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "Name" : "이름"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {name}
            </span>
          </div>
          <div className={styles.numberBox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "Contact information" : "전화번호"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {phoneNumber}
            </span>
          </div>
          <div className={styles.emailBox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "E-mail" : "이메일"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {email}
            </span>
          </div>
        </div>
        <div className={styles.paperInfo}>
          <div className={styles.infoTitle}>
            {job?.lo === "en" ? "Submitted Documents" : "제출 서류"}
          </div>
          <div className={styles.applyFileBox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "Resume, Cover letter" : "이력서"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {applyName}
            </span>
          </div>
          <div className={styles.addPaperFileBox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "Portfolio(Optional)" : "추가 제출 서류"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {portfolioName}
            </span>
          </div>
          <div className={styles.linkbox}>
            <span className={styles.eachTitle}>
              {job?.lo === "en" ? "Additional Link (Optional)" : "링크"}
            </span>
            <span
              className={!isDarkMode ? styles.eachInfo : styles.dark_eachInfo}
            >
              {link}
            </span>
          </div>
        </div>
        <div>
          <div className={styles.questionText}>
            {job?.lo === "en"
              ? "Would you like to submit your application?"
              : "지원서를 제출하시겠습니까?"}
          </div>
          <div className={styles.btnContainer}>
            {!isLoading ? (
              <input
                onClick={onSubmit}
                className={styles.submitBtn}
                value={job?.lo === "en" ? "Submit" : "지원서 제출하기"}
                type="button"
              />
            ) : (
              <div className={styles.submitBtn}>
                <Loading color={"white"} width={"40px"} height={"40px"} />
              </div>
            )}
            {!isLoading ? (
              <button
                onClick={() => setIsModal(false)}
                className={styles.backBtn}
              >
                {job?.lo === "en" ? "Edit" : "수정하기"}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Modal);
